import React from 'react'
import '../Box/Box.css'
import ContainerBackground from '../ContainerBackground/ContainerBackground'
import Navbar from '../Navbar/Navbar'
import {useTheme} from '../ThemeContext/ThemeContext';
import PanicButton from '../PanicButton/PanicButton';
import ThemeMenuButton from '../ThemeMenuButton/ThemeMenuButton';

function ActivityContainer({ children }) {
    const { currentTheme } = useTheme();

  return (
    <div>
        <ContainerBackground theme={currentTheme}
        style={{ 
            display: "flex",
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            }}>
    
        <div style={{maxWidth:"75%", margin: "0 auto"}}>
        <Navbar/>
        
            {children}
            
        </div>
        <ThemeMenuButton/>
        <PanicButton style={{marginBottom: "2rem"}}/>
        </ContainerBackground>
    </div>
  );
};

export default ActivityContainer

